export enum EventStatus {
  Draft = 0,
  Published = 1,
  Archived = 2
}
